var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowDownDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57 5.987l5.2 5.261a.555.555 0 00.793 0l5.2-5.261a.828.828 0 000-1.161.806.806 0 00-1.148 0l-4.449 4.5-4.447-4.5a.806.806 0 00-1.148 0 .829.829 0 000 1.161z",
    fill: "#70777E"
  })));
}

export default SvgIconArrowDownDropdown;